// extracted by mini-css-extract-plugin
module.exports = {"root":"UsergroupDetailView_root__2Vl38","buttonContainer":"UsergroupDetailView_buttonContainer__2quq3"};